// client/src/components/PromoStrip.js
import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import { formatCurrency } from '../utils/currency';
import { FREE_SHIPPING_THRESHOLD } from '../constants/shipping';

const PROMISES = [
  { icon: <LocalShippingOutlinedIcon sx={{ fontSize: 16 }} />, text: `Free delivery over ${formatCurrency(FREE_SHIPPING_THRESHOLD)}` },
  { icon: <AutorenewIcon sx={{ fontSize: 16 }} />, text: '30-day easy returns' },
  { icon: <AccountBalanceOutlinedIcon sx={{ fontSize: 16 }} />, text: 'Pay by EFT' },
];

const PromoStrip = () => (
  <Box
    className="no-print"
    sx={{
      bgcolor: '#0B0D12',
      color: '#fff',
      py: 0.75,
      px: 2,
      overflow: 'hidden',
    }}
  >
    <Stack
      direction="row"
      spacing={{ xs: 2, md: 6 }}
      justifyContent={{ xs: 'flex-start', md: 'center' }}
      alignItems="center"
      sx={{ flexWrap: 'nowrap', overflowX: 'auto', '&::-webkit-scrollbar': { display: 'none' } }}
    >
      {PROMISES.map((item) => (
        <Stack key={item.text} direction="row" spacing={0.75} alignItems="center" sx={{ flexShrink: 0 }}>
          <Box sx={{ color: 'primary.light', display: 'flex' }}>{item.icon}</Box>
          <Typography variant="caption" fontWeight={600} sx={{ letterSpacing: '0.02em', whiteSpace: 'nowrap' }}>
            {item.text}
          </Typography>
        </Stack>
      ))}
    </Stack>
  </Box>
);

export default PromoStrip;
